<template>
  <div class="card" v-bind:class="cardColor">
    <h2 class="card-h2" v-if="title" v-bind:class="[{'s-icon': cardIcon}]">
      <span><i v-if="cardIcon" class="material-icons card-icon">{{cardIcon}}</i> {{title}}</span>
    </h2>
    <div class="card-content">
      <BarChart :bar-color="barColor"
                :chart-data="chartData" 
                :chart-height="chartHeight"
                :chart-type="chartType"
                :label-prefix="labelPrefix"
                :legend-color="legendColor"
                :legend-link="legendLink"
                :show-legend="showLegend"
                :stacked="stacked"
                :x-max-axes-rotation="xMaxAxesRotation"
                :x-min-axes-rotation="xMinAxesRotation"></BarChart>

      <table v-if="json.amounts && json.amounts.length" v-bind:class="tableColor">
        <thead>
          <tr>
            <th>{{title}}</th>
            <th>%</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in chartData">
            <td>{{ data.title }}</td>
            <td>{{ Number(data.percent).toLocaleString('en-US', {maximumFractionDigits: 2}) }}%</td>
            <td>{{ Number(data.amount).toLocaleString('en-US') }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="highlight" colspan="2">Total</td>
            <td class="highlight">{{ Number(json.total).toLocaleString('en-US') }}</td>
          </tr>
          <tr v-if="noDataAvailable">
            <td colspan="2">No data available</td>
            <td>{{ Number(noDataAvailable.amount).toLocaleString('en-US') }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/barCharts/BarChart'

export default {
  name: 'barChartWithTable',

  props: {
    'cardColor': {
      type: String,
      required: false
    },
    'cardIcon': {
      type: String,
      required: false
    },
    'getter': {
      type: String,
      required: true
    },
    'tableColor': {
      type: String,
      required: false
    },
    'title': {
      type: String,
      required: false
    },

    // == Bar Chart options/props in BarChart.vue

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'bar'
    },
    'labelPrefix': {
      type: String,
      required: false
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: false
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': BarChart
  },

  computed: {
    json () {
      return this.$store.getters[this.getter]
    },

    chartData () {
      if (this.json.amounts) {
        return this.json.amounts.filter(function (series) {
          return series.title !== 'No data available'
        })
      }

      return []
    },

    noDataAvailable () {
      if (this.json.amounts) {
        return this.json.amounts.filter(function (series) {
          return series.title === 'No data available'
        })[0]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BarChartWithTable.vue?153f6c38